var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"tabSwitcher",staticClass:"p-2 bg-white sticky top-0 z-20",class:{'shadow': _vm.isStuck}},[_c('div',{staticClass:"flex flex-row p-1 mx-auto rounded-full border border-solid",class:{
    'border-green-300': _vm.activeTab === 0,
    'border-blue-300': _vm.activeTab === 1,
  },staticStyle:{"max-width":"452px"}},_vm._l((_vm.tabs),function(tab){return _c('TabSwitcherItem',{key:tab.id,attrs:{"label":_vm.belowSmBreakpoint ? tab.shortLabel : tab.label,"isActive":_vm.activeTab === tab.id,"id":tab.id},on:{"click":(id) => _vm.handleClick(id, tab)}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }